import React from "react";
import "./Become_a_dealer.css";
import Common_Btn from "../../common/common-btn/Common_Btn";
import { useNavigate } from "react-router-dom";
import { PowerProgress } from "../../../utils/apis/homepage/index";
import { Power } from "../../../utils/apis/homepage/index";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import { useLocation } from "react-router-dom";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Become_a_dealer = () => {
  const navigate = useNavigate();

  // console.log(Power,"PowerPower")

  const { IMG_URL } = useContext(Context);
  const location = useLocation();

  const [powerData, setPowerData] = useState([]);

  const getPower = async () => {
    try {
      const res = await Power();
      // console.log("Power API Response in component:", res?.data?.data);
      const actualData = res?.data?.data || [];
      setPowerData(actualData);
    } catch (error) {
      console.error("Error fetching power data:", error);
    }
  };

  useEffect(() => {
    getPower();
  }, []);

  console.log(powerData, "PowerPower");

  // const rowData = [
  //   {
  //     number: powerprogress?.happycustomers,
  //     text1: "Happy Customers",
  //     text2: "Trusted by homeowners, societies, and businesses.",
  //     img: "/assets/images/home/power_progress/rating.png"
  //   },
  //   {
  //     number: powerprogress?.qualitychecked,
  //     text1: "Quality Checked",
  //     text2: "Engineered for performance, safety, and long-term savings.",
  //     img: "/assets/images/home/power_progress/surface1.png"
  //   },
  //   {
  //     number: powerprogress?.energycostsavings,
  //     text1: "Energy Cost Savings",
  //     text2: "Smart solar solutions designed for maximum ROI.",
  //     img: "/assets/images/home/power_progress/profit.png"
  //   },
  //   {
  //     number: powerprogress?.supportmonitoring,
  //     text1: "Support & Monitoring",
  //     text2: "Ensuring uninterrupted solar performance year-round.",
  //     img: "/assets/images/home/power_progress/support.png"
  //   },
  // ];

  // console.log(process.env.REACT_APP_BASE_URL,"link")

  return (
    <section className="Become_a_dealer">
      <div className="custom_container">
        <div className="power_banner_div">
          <div className="banner_img_holder">
            <img
              src="/assets/images/home/become_a_dealer/handshake-businessmen.png"
              alt="banner img"
              className="banner_img"
            />
          </div>

          <div className="power_banner_content_holder">
            <div className="power_banner_header">
              <h5 className="banner_header">Become Our Trusted Partner</h5>
              <p className="banner_subtitle">
                Apply now to become an official dealer & unlock new business
                potential.
              </p>
            </div>

            <div className="know_more_btn">
              {location.pathname !== "/about-us" && (
                <div className="btn_wrapper">
                  <Common_Btn  onClick={() => navigate("/contact-us")}
                    text={
                      <>
                        BECOME A DEALER <FontAwesomeIcon icon={faAngleRight} />
                      </>
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Become_a_dealer;
